var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-alert-group"},[_c('v-alert',{attrs:{"alert":_vm.alert},on:{"closed":_vm.shiftAlert}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }